<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h1 class="header">Please provide these additional details.</h1>
                <h2 class="subheader"></h2>
            </div>
        </div>
        <div v-if="generalErrorMessage" class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <div class="alert alert-danger" role="alert">
                    {{ generalErrorMessage }}
                </div>
            </div>
            <div class="col-xl-3"></div>
        </div>
        <div class="row">
            <div class="col-xl-3"></div>
            <div class="col">
                <form @submit.prevent="submit()">
                    <div class="form-row">
                        <div class="col-md-6">
                            <b-form-group v-if="promptMaritalStatus" label="Marital Status" :state="stateForField('maritalStatusId')" :invalid-feedback="errorForField('maritalStatusId')">
                                <b-form-select size="lg" @input="clearFieldError('maritalStatusId')" :state="stateForField('maritalStatusId')" v-model="demographics.maritalStatusId" :options="maritalStatusRadioOptions"></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group v-if="promptSsn || promptSsnOptional" id="ssnGroup" label="Social Security Number" :state="stateForField('ssn')" :invalid-feedback="errorForField('ssn')">
                                <b-form-input id="ssn" @input="clearFieldError('ssn')" size="lg" :state="stateForField('ssn')" v-model="demographics.ssn"></b-form-input>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <b-form-group v-if="promptDominantHand" label="Dominant Hand" :state="stateForField('dominantHandId')" :invalid-feedback="errorForField('dominantHandId')">
                                <b-form-select size="lg" @input="clearFieldError('dominantHandId')" :state="stateForField('dominantHandId')" v-model="demographics.dominantHandId" :options="dominantHandRadioOptions"></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">

                        </div>
                    </div>
                    <div class="form-row">
                        <button type="submit" @click.prevent="submit()" class="btn btn-primary btn-lg mx-auto mt-2" style="width: 40%"><font-awesome-icon class="mr-2" v-show="isSaving" icon="spinner" pulse/>Next</button>
                    </div>
                </form>
            </div>
            <div class="col-xl-3"></div>
        </div>
    </div>
</template>

<script>
  import api from '../../services/api'
  import ErrorsMixin from '../../mixins/ErrorsMixin'
  import OptionsMixin from '../../mixins/OptionsMixin'
  import DemographicsMixin from '../../mixins/DemographicsMixin'
  import { BFormSelect, BFormGroup, BFormInput } from 'bootstrap-vue'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'DemographicsAdditional',

    components: { BFormGroup, BFormInput, BFormSelect },

    mixins: [ErrorsMixin, OptionsMixin, DemographicsMixin, AnalyticsMixin],

    data () {
      return {
        demographics: {},
        isSaving: false
      }
    },

    computed: {
      maritalStatusRadioOptions () {
        return this.optionsFromArray(this.demographics.maritalStatusOptions, 'maritalStatusId')
      },

      dominantHandRadioOptions () {
        return this.optionsFromArray(this.demographics.dominantHandOptions, 'dominantHandId')
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (this.promptMaritalStatus && !this.demographics.maritalStatusId) {
          this.addErrorForField('maritalStatusId', 'Marital status is required.')
        }

        if (this.promptSsn && !this.demographics.ssn && !this.promptSsnOptional) {
          this.addErrorForField('ssn', 'Social security is required.')
        }

        if (this.promptDominantHand && !this.demographics.dominantHandId) {
          this.addErrorForField('dominantHandId', 'Dominant hand is required.')
        }

        return !this.hasErrors()
      },

      loadData () {
        api.get('/Patient/Demographics').then(response => {
          this.trackEvent(this.$options.name, 'Load', 'ResponseTime', response.config.requestDuration)
          this.demographics = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error searching for loading demographics: ' + error.message, error)
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
            if (error.response && error.response.data) {
              this.setErrorsFromResponse(error.response.data)
            } else if (error.message) {
              this.addErrorForField('exception', error.message)
            }
          }
        })
      },

      submit () {
        if (this.validate() !== true) {
          return
        }

        this.isSaving = true
        api.put('/Patient/Demographics', this.demographics).then(response => {
          this.trackEvent(this.$options.name, 'Save', 'ResponseTime', response.config.requestDuration)
          if (this.promptAdditionalPhone) {
            this.isSaving = false
            this.$router.push('/demographics-phone')
          } else {
            this.$store.setModuleStatus('Demographics', true, () => {
              this.isSaving = false
              this.$router.push(this.$store.nextRoute())
            })
          }
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            this.$log.error('Error saving demographics: ' + error.message, error)
            if (error.response && error.response.data) {
              this.setErrorsFromResponse(error.response.data)
            } else if (error.message) {
              this.addErrorForField('exception', error.message)
            }
          }
        })
      }
    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>

</style>
